import "../template-parts/cool-room-booker/cool-room-booker.js";
import "../template-parts/cool-room-booker/cool-room-booker.scss";
import "../template-parts/modal/modal.scss";
import "../template-parts/login-modal/login-modal.scss";
